import React from 'react'
import { useTranslation } from 'react-i18next'
import './messageArea.sass'

interface Props {
    externalState: string
    setExternalState: React.Dispatch<React.SetStateAction<string>>
    label: string
    externalClass?: string
}

const MessageArea: React.FunctionComponent<Props> = ({
    externalState,
    setExternalState,
    label,
    externalClass = ''
}: Props) => {
    const [t] = useTranslation()
    return (
        <div className={externalClass ? externalClass : 'messageArea'}>
            <strong>{label + t('dots')}</strong>
            <textarea
                value={externalState}
                onChange={(e) => {
                    setExternalState(e.target.value)
                }}
            ></textarea>
        </div>
    )
}

export default MessageArea
